import ruFlag from '@/assets/images/flags/flag-ru.svg'
import enFlag from '@/assets/images/flags/flag-en.svg'
import kzFlag from '@/assets/images/flags/ flag-kz.svg'
import { useTranslation } from 'react-i18next'

const langaugesList = [
  { code: 'ru', label: 'Русский', flagImg: ruFlag },
  { code: 'en', label: 'English', flagImg: enFlag },
  { code: 'kz', label: 'Қазақша', flagImg: kzFlag }
]

const useLanguage = () => {
  const { i18n } = useTranslation();
  
  const currentLanguageCode = (
    i18n.resolvedLanguage 
    || i18n.language 
    || langaugesList[0].code
  ).split('-')[0];

  // const currentLanguage = useMemo(() => (
  //   langaugesList.find((lang) => lang.code === currentLanguageCode) 
  //   || langaugesList[0]
  // ), [currentLanguageCode]);

  const setLanguage = (code) => {
    i18n.changeLanguage(code)
    localStorage.setItem('i18nextLng', code)
  }
  return {
    currentLanguageCode,
    // currentLanguage,
    langaugesList,
    setLanguage,
  }
}

export default useLanguage;